import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Parse a free-form gene list (comma, whitespace, or newline-separated). */
export function parseGeneList(input: string): string[] {
  return Array.from(
    new Set(
      input
        .split(/[,\s\n]+/)
        .map((s) => s.trim())
        .filter(Boolean),
    ),
  );
}

/** Display-only STRING score conversion (INT-01 — always labelled as a display conversion). */
export function toDisplayScore(raw: number | undefined | null): number {
  if (raw == null || Number.isNaN(raw)) return 0;
  return Math.round(Math.max(0, Math.min(1, raw)) * 1000);
}
